import SearchIcon from '@components/icons/Search.svg';
import { cn } from '@helpers/cn';
import { TProps } from './types/TProps';

export const SearchToggle = ({ expanded, active, onClick }: TProps) => (
  <button
    type="button"
    aria-label="Search"
    aria-expanded={expanded}
    onClick={onClick}
    className={cn(
      'group relative flex min-h-11 min-w-11 cursor-pointer items-center justify-center rounded-[5px] p-[3px] hover:bg-tint',
      expanded && 'bg-surface-muted',
    )}
  >
    <SearchIcon className="h-6 w-6 [&>path]:fill-foreground-muted group-hover:[&>path]:fill-[var(--color-on-surface)]" />
    {active ? <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-[var(--color-tint)]" /> : null}
  </button>
);
